import React from "react";
import PropTypes from "baobab-react/prop-types";
import { branch } from "baobab-react/higher-order";
import _ from "lodash";
import autoBind from "react-autobind";

import { Panel } from "react-bootstrap";
import FontAwesome from "react-fontawesome";
// import ClickNHold from "react-click-n-hold";

import PlayerItem from "../playerItemComponents/PlayerItem";
import PlayerTextInput from "../playerItemComponents/PlayerTextInput";
import PlayerTextInputMultiline from "../playerItemComponents/PlayerTextInputMultiline";
import PlayerPicker from "../playerItemComponents/PlayerPicker";
import PlayerYesNo from "../playerItemComponents/PlayerYesNo";
import PlayerBarcodeScanner from "../playerItemComponents/PlayerBarcodeScanner";
import PlayerImagePicker from "../playerItemComponents/PlayerImagePicker";
import PlayerSketchpad from "../playerItemComponents/PlayerSketchpad";
import PlayerWeather from "../playerItemComponents/PlayerWeather";
import PlayerDatePicker from "../playerItemComponents/PlayerDatePicker";
import PlayerAddress from "../playerItemComponents/PlayerAddress";
import PlayerLocation from "../playerItemComponents/PlayerLocation";
import PlayerMultiChoice from "../playerItemComponents/PlayerMultiChoice";
import PlayerSingleChoice from "../playerItemComponents/PlayerSingleChoice";
import PlayerRanking from "../playerItemComponents/PlayerRanking";
import RankItemAnimatedCard from "../animated/RankItemAnimatedCard";

import PlayerIcon from "../playerItemComponents/PlayerIcon";
import PlayerCommentsModal from "./PlayerCommentsModal";

import * as playerActions from "../../actions/playerActions";
import { markdownToHtml } from "../../utils/markupUtils";
import * as Utils from "../../utils/utils";
import { getUrlForValue } from "../../actions/drive";

import { getConfigParam } from "../../utils/config";
import OkButtonContext from "../../contexts/OkButtonContext";

//hardwire focus mode to false
const focusMode = false;

const LIST_VIEW = "list";
let bounds = [];
// let ignoreMe = false;
//Placeholder
class ActivityPlayer extends React.PureComponent {

	constructor(props) {

		super(props);
		autoBind(this);
		console.log(this.container);

		this.itemRefs = {};
		this.itemRefsInfo = {};
		this.itemRefsOrdered = [];
		this.itemCoordinates = [];
		this.itemIndexes = {};
		this.itemSelectedId = "";
		this.disableScrollSelection = false;
		this.debouncedScroll = _.debounce(this.onScrollEnd, 150);
		this.selectedFromScroll = false;
		this.map = React.createRef();
		this.state = {
			view: LIST_VIEW,
			visibility: "hidden"
		};
	}

	componentDidMount() {

		let self = this;

		let selectedListIndex = _.get(this.props, "activity.selected.listIndex");
		let selectedSectionIndex = _.get(this.props, "activity.selected.sectionIndex");
		let selectedItemIndex = _.get(this.props, "activity.selected.itemIndex");

		this.itemSelectedId = this.getItemKey(selectedListIndex, selectedSectionIndex, selectedItemIndex);

		playerActions.ensureExpanded(this.context.tree, selectedListIndex, selectedSectionIndex);

		//seems kind of hacky
		setTimeout(() => {
			self.scrollToItem(self.itemSelectedId, true, { behavior: "instant" });
			self.setState({ visibility: "visible" });
		}, 0);

		window.addEventListener("resize", _.debounce(this.onResize, 50));
		if (!_.isEmpty(this.container) && this.props.appCapabilitiesPlayer.procedure.autoSelectOnScroll) {
			this.setState({
				paddingHeight: this.container.offsetHeight / 2
			});
		}
	}

	componentWillUnmount() {
		window.removeEventListener("resize", _.debounce(this.onResize, 50));
	}

	getItemKey(listIndex, sectionIndex, itemIndex) {
		let key = "player-list-" + listIndex + "-section-" + sectionIndex + "-item-" + itemIndex;
		return key;
	}

	onResize() {
		//console.log("resize window!");
		if (!_.isEmpty(this.container) && this.props.appCapabilitiesPlayer.procedure.autoSelectOnScroll) {
			this.setState({
				paddingHeight: this.container.offsetHeight / 2
			});
		}
	}

	onScrollEnd() {
		//if (!_.isEmpty(this.container)) {
		//	console.log("Scroll ended, top: " + this.container.scrollTop);
		//}
		if (this.disableScrollSelection) {
			if (this.props.appCapabilitiesPlayer.procedure.focusInputOnSelect) {
				this.focusInputOnSelect();
			}
		}

		//check one last time		
		if (this.props.appCapabilitiesPlayer.procedure.autoSelectOnScroll) {
			this.selectItemOnScroll();
		}

		this.disableScrollSelection = false;
	}

	focusInputOnSelect() {
		if (!Utils.isMobileBrowser()) {
			let el = document.getElementById(this.itemSelectedId);
			if (el !== null) {
				const info = this.itemRefsInfo[this.itemSelectedId];
				if (!info || info.disabled) {
					return;
				}
				let type = info.type.toLowerCase();

				if (type === "itemtextinput") {
					let input = el.querySelector("input[type=text]");
					if (input !== null) {
						input.focus();
					}
				} else if (type === "itemtextinputmultiline" || type === "itembarcodescanner") {
					let input = el.querySelector("textarea");
					//console.log("TEXT INPUT MULTIPLINE input " + input);
					if (input !== null) {
						input.focus();
					}
				}
			}
		}
	}

	componentWillReceiveProps(nextProps) {

		if (this.props.showMode !== true) {
			let nextSelectedListIndex = _.get(nextProps, "activity.selected.listIndex");
			let nextSelectedSectionIndex = _.get(nextProps, "activity.selected.sectionIndex");
			let nextSelectedItemIndex = _.get(nextProps, "activity.selected.itemIndex");

			if (!_.isUndefined(nextSelectedListIndex) && !_.isUndefined(nextSelectedSectionIndex) && !_.isUndefined(nextSelectedItemIndex)) {
				let selectedListIndex = _.get(this.props, "activity.selected.listIndex");
				let selectedSectionIndex = _.get(this.props, "activity.selected.sectionIndex");
				let selectedItemIndex = _.get(this.props, "activity.selected.itemIndex");

				if (selectedListIndex !== nextSelectedListIndex || selectedSectionIndex !== nextSelectedSectionIndex || selectedItemIndex !== nextSelectedItemIndex) {
					if (!this.selectedFromScroll) {
						this.itemSelectedId = this.getItemKey(nextSelectedListIndex, nextSelectedSectionIndex, nextSelectedItemIndex);
						console.log("Call scrollToItem from componentWillReceiveProps " + this.itemSelectedId);
						this.scrollToItem(this.itemSelectedId, true);
					} else {
						this.selectedFromScroll = false;
					}
				}
			}
		}
	}

	calculateSelectedItem(scrollTop) {
		console.time("calculateSelectedItem");
		let self = this;
		let selectedItemRef;
		let top;
		let height;
		let found = false;
		let firstItemRef;
		let firstItemKey;
		let lastItemRef;
		let lastItemKey;

		let firstItem = false;

		_.each(this.itemRefsOrdered, (key) => {

			let itemRef = self.itemRefs[key];

			if (!_.isEmpty(itemRef)) {

				if (firstItem === false) {
					firstItemRef = itemRef;
					firstItemKey = key;
					firstItem = true;
				}
				top = itemRef.offsetTop;
				height = itemRef.offsetHeight;

				//console.log("top " + top + " height: " + height + " total " + (height+top) + " scrollTop " + scrollTop + " key: " + key);

				if (scrollTop >= top && (top + height) >= scrollTop) {
					selectedItemRef = key;
					found = true;
					return false;
				}

				if (height > 0) {
					if (scrollTop > itemRef.offsetTop) {
						lastItemRef = itemRef;
						lastItemKey = key;
					}
				}
			}
		});

		if (found === false) {

			if (!_.isEmpty(firstItemRef) && firstItemRef.offsetTop > scrollTop) {
				selectedItemRef = firstItemKey;
				console.log("Top scroll out of bounds, select first item");
			} else if (!_.isEmpty(lastItemRef) && (lastItemRef.offsetTop + lastItemRef.offsetHeight) < scrollTop) {
				console.log("End of scroll out of bounds, select last item");
				selectedItemRef = lastItemKey;
			}
		}

		console.timeEnd("calculateSelectedItem");

		return selectedItemRef;
	}

	createComments(comments) {
		return { __html: comments };
	}

	scrollToItem(id, disableScrollSelection = false, scrollOptions = { behavior: "smooth" }) {
		this.disableScrollSelection = disableScrollSelection;
		// let itemRef = this.itemRefs[id];
		// if (itemRef !== null && !_.isUndefined(itemRef)) {
		// 	setTimeout(() => {
		// 		const element = itemRef;
		// 		const elementRect = element.getBoundingClientRect();
		// 		const top = elementRect.top + this.container.scrollTop - this.container.offsetTop;
		// 		const middle = top - ((this.container.clientHeight / 2) - (elementRect.height / 2));
		// 		console.log("Scrol to ", middle, top);
		// 		if (elementRect.height < this.container.clientHeight) {
		// 			this.container.scroll({
		// 				top: middle,
		// 				left: 0,
		// 				behavior: scrollOptions.behavior
		// 			});
		// 		} else {
		// 			this.container.scroll({
		// 				top: top,
		// 				left: 0,
		// 				behavior: scrollOptions.behavior
		// 			});
		// 		}
		// 	}, 300)
		// } else {
			setTimeout(() => {
				const el = document.getElementById(id);
				if (el) {
					const element = el;
					const elementRect = element.getBoundingClientRect();
					const top = (elementRect.top + this.container.scrollTop) - this.container.offsetTop;
					const middle = top - ((window.innerHeight / 2) - (elementRect.height / 2));
					console.log("Scroll to middle ", middle, this.container.scrollTop);
					console.log("Scroll top ", top);

					if (elementRect.height < window.innerHeight) {
						this.container.scroll({
							top: middle,
							left: 0,
							behavior: scrollOptions.behavior
						});
					} else {
						this.container.scroll({
							top: top,
							left: 0,
							behavior: scrollOptions.behavior
						});
					}
				}
			}, 300)

		// }
		this.debouncedScroll();
	}

	handleScroll() {
		this.debouncedScroll();

		//console.log("Handle scroll, disableScrollSelection: " + this.disableScrollSelection);
		//console.log("scroll top " + this.container.scrollTop);
		//console.log("scroll height " + this.container.scrollHeight);
		//console.log("item coordinates length " + this.itemCoordinates.length);
		//console.log("container offset height: " + this.container.offsetHeight);
		if (this.props.appCapabilitiesPlayer.procedure.autoSelectOnScroll) {
			this.selectItemOnScroll();
		}
	}

	selectItemOnScroll() {
		if (this.disableScrollSelection === false) {
			let scrollTop = parseInt(this.container.scrollTop + (this.container.offsetHeight / 2) + 100, 10);
			//console.log(scrollTop + " calculated scroll top");
			let itemId = this.calculateSelectedItem(scrollTop);


			//console.log("SELECTED " + itemId);
			if (itemId !== this.itemSelectedId && !_.isUndefined(itemId)) {
				let indexes = this.itemIndexes[itemId];
				this.selectedFromScroll = true;
				this.setSelectedItem(this.context.tree, indexes[0], indexes[1], indexes[2], itemId, false);
			}
		}
	}

	setSelectedItem(tree, i, j, k, id) {
		this.itemSelectedId = id;
		playerActions.setSelectedItem(tree, i, j, k);
	}

	getCompletionStateColor(completionState) {
		let completedColor = "#BA282A";
		if (completionState === "i") {
			completedColor = "#F9A200";
		} else if (completionState === "c") {
			completedColor = "#4f7017";
		}
		return completedColor;
	}

	handleListExpandAll(listIndex) {
		this.props.dispatch(
			playerActions.listExpandAll,
			listIndex
		);
	}

	handleListCollapseAll(listIndex) {
		this.props.dispatch(
			playerActions.listCollapseAll,
			listIndex
		);
	}

	handleViewSwitch(view) {
		if (this.state.view !== view) {
			this.setState({ view });
		}
	}

	handleMapMounted(map) {

		if (map) {
			this._map = map;
			setTimeout(() => {
				map.fitBounds(bounds);
			});
		}
	}

	handleShowCommentsModal() {
		this.props.dispatch(
			playerActions.showComments
		)
	}

	handleCommentsModalClose() {
		this.props.dispatch(
			playerActions.hideComments
		)
	}

	handleShowCommentsModalLongPress(t, e) {
		let nativeEvent = e.nativeEvent;
		//only respond to left mouse button or touch events
		if ((nativeEvent instanceof MouseEvent && e.button === 0) ||
			nativeEvent instanceof TouchEvent) {
			this.props.dispatch(
				playerActions.showComments
			)
		}
	}

	render() {
		let self = this;

		const webMode = getConfigParam("webMode", false);

		let lists;
		let identityId = this.props.user.identityId;

		const theme = this.props.activityTheme ? this.props.activityTheme : window.activityTheme;
		//this is for the case where an admin might be editing an existing checklist
		let activityIdentityId = this.props.activityIdentityId;
		//let identityId = "test-identity-id";

		let flatItems = [];

		let listCount = 0;
		let sectionCount = 0;
		let itemCount = 0;

		self.props.activity.children.forEach(list => {
			listCount++;
			sectionCount += list.children ? list.children.length : 0;
		});

		try {
			if (self.props.activity && self.props.activity.children) {
				lists = self.props.activity.children.map((list, i) => {
					let sections = list.children.map((section, j) => {
						let items = section.children.map((item, k) => {

							//let comments;
							//let notes;
							let mediaAttachmentsComponent;

							/*
							if (item.hasOwnProperty("comments") && item.comments !== "" && self.props.hasOwnProperty("preview") && self.props.preview) {
								comments =
									<div style={{ borderStyle: "solid", borderWidth: 1, borderColor: "gold", borderRadius: 5, backgroundColor: "lightyellow", padding: 10, margin: 10 }}>
										<b>Comments</b><br />
										<div dangerouslySetInnerHTML={self.createComments(item.comments)} />
									</div>;
							}


							if (item.hasOwnProperty("notes") && item.notes !== "") {
								notes =
									<div style={{ borderStyle: "solid", borderWidth: 1, borderColor: "blue", borderRadius: 5, backgroundColor: "lightblue", padding: 10, margin: 10 }}>
										<b>Notes</b><br />
										{item.notes}
									</div>;
							}
							*/

							let mediaAttachments;
							if (item.hasOwnProperty("mediaAttachmentsUrls") && item.mediaAttachmentsUrls.length > 0) {
								try {
									let imgUrls = "";
									for (let i = 0; i < item.mediaAttachmentsUrls.length; i++) {
										// Need to loop through all values
										let imgUrlParts = item.mediaAttachmentsUrls[i].split(".");
										let ext = imgUrlParts[imgUrlParts.length - 1];
										let imgUrl;
										if (ext === "mp4" || ext === "mov" || ext === "avi") {
											imgUrl = "<p><b>Video Thumbnail</b><br/><a href='" + item.mediaAttachmentsUrls[i].replace("." + ext, ".mp4") + "' target='blank'><img src='" + item.mediaAttachmentsUrls[i].replace("." + ext, "-00001.png") + "' /></a></p>";
										} else {
											imgUrl = "<p><b>Photo</b><br/><a href='" + item.mediaAttachmentsUrls[i] + "' target='blank'><img style='width: 50%' src='" + item.mediaAttachmentsUrls[i] + "' /></a></p>";
										}

										imgUrls = imgUrls + imgUrl;
									}

									mediaAttachments =
										<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
											<div style={{ width: "100%", overflowX: "auto" }}>
												<div dangerouslySetInnerHTML={markdownToHtml(imgUrls)} />
											</div>
										</div>;

								} catch (e) {
									alert(e);
								}

								mediaAttachmentsComponent =
									<div style={{ borderStyle: "solid", borderWidth: 1, borderColor: "blue", borderRadius: 5, backgroundColor: "lightblue", padding: 10, margin: 10 }}>
										<b>Media Attachments</b><br />
										{mediaAttachments}
									</div>;
							}

							let component;
							let itemVisible = Utils.isVisible(item);
							let selected = (itemVisible) ? playerActions.itemSelected(self.context.tree, i, j, k) : false;
							const disabled = item.hasOwnProperty("enabled") && !item.enabled;

							if (item.type.toLowerCase() === "item") {
								component = <PlayerItem
									theme={_.get(this.props.activityTheme, "item.check")}
									listIndex={i}
									sectionIndex={j}
									itemIndex={k}
									item={item}
									activityStyles={this.props.activity.styles}
									listStyles={list.styles}
									sectionStyles={section.styles}
									readOnly={self.props.readOnly}
									showMode={self.props.showMode}
									disabled={disabled}
									onSubmit={(checked) => {
										if (!disabled) {
											playerActions.setItemChecked(
												self.context.tree,
												i, j, k,
												checked,
												identityId,
												item.linkOnCheck,
												item.linkId,
												item.linkActionType
											);
										}
									}}
									selected={selected}
								/>;
							} else if (item.type.toLowerCase() === "itemtextinput") {
								try {
									component = <PlayerTextInput
										theme={_.get(this.props.activityTheme, "item.textInput")}
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										activityStyles={this.props.activity.styles}
										listStyles={list.styles}
										sectionStyles={section.styles}
										readOnly={self.props.readOnly}
										showMode={self.props.showMode}
										disabled={disabled}
										onChange={(value) => {
											if (!disabled) {
												playerActions.handleChangeProperty(
													self.context.tree,
													i, j, k,
													"value",
													value
												);
											}
										}}
										onSubmit={(value) => {
											if (!disabled) {
												playerActions.setItemTextInputChecked(
													self.context.tree,
													i, j, k,
													value,
													identityId,
													item.linkOnCheck,
													item.linkId,
													item.linkActionType
												);
											}
										}}
										selected={selected} />;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemtextinputmultiline") {
								try {
									component = <PlayerTextInputMultiline
										theme={_.get(this.props.activityTheme, "item.textInputMultiline")}
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										activityStyles={this.props.activity.styles}
										listStyles={list.styles}
										sectionStyles={section.styles}
										readOnly={self.props.readOnly}
										showMode={self.props.showMode}
										disabled={disabled}
										onChange={(value) => {
											if (!disabled) {
												playerActions.handleChangeProperty(
													self.context.tree,
													i, j, k,
													"value",
													value
												);
											}
										}}
										onSubmit={(value) => {
											if (!disabled) {
												playerActions.setItemTextInputChecked(
													self.context.tree,
													i, j, k,
													value,
													identityId,
													item.linkOnCheck,
													item.linkId,
													item.linkActionType
												);
											}
										}} />;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itempicker") {
								try {
									component = <PlayerPicker
										theme={_.get(this.props.activityTheme, "item.picker")}
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										activityStyles={this.props.activity.styles}
										listStyles={list.styles}
										sectionStyles={section.styles}
										readOnly={self.props.readOnly}
										showMode={self.props.showMode}
										disabled={disabled}
										onChange={(value) => {
											if (!disabled) {
												playerActions.handleChangeProperty(
													self.context.tree,
													i, j, k,
													"value",
													value
												);
											}
										}}
										onSubmit={(value, linkOnSelect, linkId, linkActionType) => {
											if (!disabled) {
												playerActions.setItemPickerChecked(
													self.context.tree,
													i, j, k,
													value,
													identityId,
													linkOnSelect,
													linkId,
													linkActionType
												);
											}
										}}
										selected={selected} />;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemranking") {
								try {
									component = <PlayerRanking
										theme={_.get(this.props.activityTheme, "item.picker")}
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										activityStyles={this.props.activity.styles}
										listStyles={list.styles}
										sectionStyles={section.styles}
										readOnly={self.props.readOnly}
										showMode={self.props.showMode}
										disabled={disabled}
										onChange={(value) => {
											if (!disabled) {
												playerActions.handleChangeProperty(
													self.context.tree,
													i, j, k,
													"value",
													value
												);
											}
										}}
										onSubmit={(value) => {
											if (!disabled) {
												playerActions.setItemRankingChecked(
													self.context.tree,
													i, j, k,
													value,
													identityId
												);
											}
										}}
										selected={selected} />;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemyesno") {
								try {
									component = <PlayerYesNo
										theme={_.get(this.props.activityTheme, "item.yesNo")}
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										activityStyles={this.props.activity.styles}
										listStyles={list.styles}
										sectionStyles={section.styles}
										readOnly={self.props.readOnly}
										showMode={self.props.showMode}
										disabled={disabled}
										onSubmit={(value) => {
											if (!disabled) {
												playerActions.setItemYesNoChecked(
													self.context.tree,
													i, j, k,
													value,
													identityId,
													item.yesNoLinkOnSelect,
													item.yesNoLinkActionType,
													item.yesNoYesLinkId,
													item.yesNoNoLinkId,
													item.yesNoNaLinkId
												);
											}
										}}
										selected={selected} />;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itembarcodescanner") {
								try {
									component = <PlayerBarcodeScanner
										theme={_.get(this.props.activityTheme, "item.barcodeScanner")}
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										activityStyles={this.props.activity.styles}
										listStyles={list.styles}
										sectionStyles={section.styles}
										readOnly={self.props.readOnly}
										showMode={self.props.showMode}
										disabled={disabled}
										onChange={(value) => {
											if (!disabled) {
												playerActions.handleChangeProperty(
													self.context.tree,
													i, j, k,
													"value",
													value
												);
											}
										}}
										onSubmit={(value) => {
											if (!disabled) {
												playerActions.setItemBarcodeChecked(
													self.context.tree,
													i, j, k,
													value,
													identityId
												);
											}
										}}
										selected={selected} />;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemimagepicker") {
								try {
									component = <PlayerImagePicker
										theme={_.get(this.props.activityTheme, "item.mediaPicker")}
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										activityStyles={this.props.activity.styles}
										listStyles={list.styles}
										sectionStyles={section.styles}
										readOnly={self.props.readOnly}
										identityId={(activityIdentityId) ? activityIdentityId : identityId}
										showMode={self.props.showMode}
										disabled={disabled}
										onChange={(value, valueUrls) => {
											if (!disabled) {
												playerActions.handleChangeProperty(
													self.context.tree,
													i, j, k,
													"value",
													value
												);
												playerActions.handleChangeProperty(
													self.context.tree,
													i, j, k,
													"valueUrls",
													valueUrls
												);
												playerActions.addMediaAttachmentHistoryEntry(
													self.context.tree,
													i, j, k,
													value,
													valueUrls,
													true,
													identityId);
											}
										}}
										onSubmit={(value, valueUrls) => {
											if (!disabled) {
												playerActions.setItemImagePickerAddMedia(
													self.context.tree,
													i, j, k,
													value,
													valueUrls,
													true,
													identityId
												);
											}
										}}
										selected={selected} />;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemsketchpad") {
								try {
									component = <PlayerSketchpad
										theme={_.get(this.props.activityTheme, "item.sketchPad")}
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										activityStyles={this.props.activity.styles}
										listStyles={list.styles}
										sectionStyles={section.styles}
										readOnly={self.props.readOnly}
										disabled={disabled}
										onSubmit={(value) => {
											if (!disabled) {
												playerActions.setItemDateChecked(
													self.context.tree,
													i, j, k,
													"",
													item.type,
													identityId,
													item.linkOnCheck,
													item.linkId,
													item.linkActionType
												);
											}
										}}
										showMode={self.props.showMode} />;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemweather") {
								try {
									component = <PlayerWeather
										theme={_.get(this.props.activityTheme, "item.weather")}
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										activityStyles={this.props.activity.styles}
										listStyles={list.styles}
										sectionStyles={section.styles}
										readOnly={self.props.readOnly}
										disabled={disabled}
										onSubmit={(value) => {
											if (!disabled) {
											}
										}}
										showMode={self.props.showMode} />;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemdate" || item.type.toLowerCase() === "itemtime" || item.type.toLowerCase() === "itemdatetime") {
								try {
									component = <PlayerDatePicker
										theme={_.get(this.props.activityTheme, "item.datePicker")}
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										activityStyles={this.props.activity.styles}
										listStyles={list.styles}
										sectionStyles={section.styles}
										readOnly={self.props.readOnly}
										showMode={self.props.showMode}
										disabled={disabled}
										onChange={(value) => {
											if (!disabled) {
												playerActions.handleChangeProperty(
													self.context.tree,
													i, j, k,
													"value",
													value
												);
											}
										}}
										onSubmit={(value) => {
											if (!disabled) {
												playerActions.setItemDateChecked(
													self.context.tree,
													i, j, k,
													value,
													item.type,
													identityId,
													item.linkOnCheck,
													item.linkId,
													item.linkActionType
												);
											}
										}}
										selected={selected} />;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemaddress") {
								try {
									component = <PlayerAddress
										theme={_.get(this.props.activityTheme, "item.addressSearch")}
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										activityStyles={this.props.activity.styles}
										listStyles={list.styles}
										sectionStyles={section.styles}
										readOnly={self.props.readOnly}
										showMode={self.props.showMode}
										disabled={disabled}
										onChange={(value) => {
											if (!disabled) {
												playerActions.handleChangeProperty(
													self.context.tree,
													i, j, k,
													"value",
													value
												);
											}
										}}
										onSubmit={(value) => {
											if (!disabled) {
												playerActions.setItemLocationChecked(
													self.context.tree,
													i, j, k,
													value,
													identityId,
													item.linkOnCheck,
													item.linkId,
													item.linkActionType
												);
											}
										}}
										selected={selected} />;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemlocation") {
								try {
									component = <PlayerLocation
										theme={_.get(this.props.activityTheme, "item.addressSearch")}
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										activityStyles={this.props.activity.styles}
										listStyles={list.styles}
										sectionStyles={section.styles}
										readOnly={self.props.readOnly}
										showMode={self.props.showMode}
										disabled={disabled}
										onChange={(value) => {
											if (!disabled) {
												playerActions.handleChangeProperty(
													self.context.tree,
													i, j, k,
													"value",
													value
												);
											}
										}}
										onSubmit={(value) => {
											if (!disabled) {
												playerActions.setItemLocationChecked(
													self.context.tree,
													i, j, k,
													value,
													identityId,
													item.linkOnCheck,
													item.linkId,
													item.linkActionType
												);
											}
										}}
										selected={selected} />;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemchoicemulti") {
								try {
									component = <PlayerMultiChoice
										theme={_.get(this.props.activityTheme, "item.choice")}
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										activityStyles={this.props.activity.styles}
										listStyles={list.styles}
										sectionStyles={section.styles}
										readOnly={self.props.readOnly}
										disabled={disabled}
										onChange={(value) => {
											if (!disabled) {
												playerActions.handleChangeProperty(
													self.context.tree,
													i, j, k,
													"value",
													value
												);
											}
										}}
										onSubmit={(value) => {
											if (!disabled) {
												playerActions.setItemChoiceMultiChecked(
													self.context.tree,
													i, j, k,
													value,
													identityId,
													item.linkOnCheck,
													item.linkId,
													item.linkActionType
												);
											}
										}} />;
								} catch (e) {
									console.error(e);
								}
							} else if (item.type.toLowerCase() === "itemchoicesingle") {
								try {
									component = <PlayerSingleChoice
										theme={_.get(this.props.activityTheme, "item.choice")}
										listIndex={i}
										sectionIndex={j}
										itemIndex={k}
										item={item}
										activityStyles={this.props.activity.styles}
										listStyles={list.styles}
										sectionStyles={section.styles}
										readOnly={self.props.readOnly}
										showMode={self.props.showMode}
										disabled={disabled}
										onChange={(value) => {
											if (!disabled) {
												playerActions.handleChangeProperty(
													self.context.tree,
													i, j, k,
													"value",
													value
												);
											}
										}}
										onSubmit={(value, choiceItem) => {
											if (!disabled) {
												playerActions.setItemChoiceSingleChecked(
													self.context.tree,
													i, j, k,
													value,
													choiceItem,
													identityId,
													item.linkOnCheck,
													item.linkId,
													item.linkActionType
												);
											}
										}}
										selected={selected} />;
								} catch (e) {
									console.error(e);
								}
							}

							//TODO: Does visible logic belong outside component?

							let itemComponent = null;
							let key = self.getItemKey(i, j, k);
							if (itemVisible) {

								let additionalStyles = {};
								if (item.resolvedStyles && item.resolvedStyles.item) {
									additionalStyles = item.resolvedStyles.item;
								}
								let borderColor = Utils.getThemeValue("item.selectedDisabledColor", "lightgray");

								let notSelectedDiv;

								if (selected) {
									borderColor = Utils.getThemeValue("item.selectedColor", "green");
								} else if (focusMode) {
									//overlay transparent div if focusMode is on and item not selected
									notSelectedDiv = <div style={{ width: "100%", height: "100%", position: "absolute", backgroundColor: "rgba(255,255,255,.6)", left: "0px", top: "0px" }}></div>;
								}

								let type = item.type.toLowerCase();

								let commentsIcon;
								const dialComponents = [];
								const commentsNotesIconColor = selected ? theme.attachments.selectedIcon.color : theme.attachments.icon.color;
								if (!Utils.isBlank(item.comments)) {
									commentsIcon =
										<div key="comments-icon" style={{ width: 20, height: 20, fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center" }}>
											<FontAwesome name='file-text-o' color={commentsNotesIconColor} style={{ color: commentsNotesIconColor }} />
										</div>;
									dialComponents.push(commentsIcon);
								}

								let notesIcon;
								if (!Utils.isBlank(item.notes)) {
									notesIcon =
										<div key="notes-icon" style={{ width: 20, height: 20, fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center" }}>
											<FontAwesome name='commenting-o' color={commentsNotesIconColor} style={{ color: commentsNotesIconColor }} />
										</div>;
									dialComponents.push(notesIcon);
								}

								let mediaIcon;
								if (!Utils.isBlank(item.mediaAttachments) && item.mediaAttachments.length > 0) {
									mediaIcon =
										<div key="media-icon" style={{ width: 20, height: 20, fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center" }}>
											<FontAwesome name='photo' color={commentsNotesIconColor} style={{ color: commentsNotesIconColor }} />
										</div>;
									dialComponents.push(mediaIcon);
								}

								let commentsNotesIcon;
								let itemContainerPadding = 10;

								/*
								Adding + icon causes content to shift left
								*/

								const focusedMode = getConfigParam("focusedMode", webMode ? false : true);
								let focusedModeSelection = "";
								if (focusedMode) {
									if (!selected) {
										borderColor = Utils.getThemeValue("item.selectedDisabledColorFocusedMode", "lightgray");
									}
									focusedModeSelection = " not-selected";
								}

								if (selected && dialComponents.length === 0) {
									let plusIcon = <div key="plus-icon" style={{ width: 20, fontSize: 16, height: 20, display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "1px" }}>
										<FontAwesome name='plus' color={commentsNotesIconColor} style={{ color: commentsNotesIconColor }} />
									</div>;
									dialComponents.push(plusIcon);
								}
								const _style = _.assign({}, { display: "flex", flexDirection: "column", borderStyle: "solid", borderColor: borderColor, borderRadius: 5, backgroundColor: item.labelOnly ? !_.isEmpty(item.labelOnlyBackgroundColor) ? item.labelOnlyBackgroundColor : "" : item.backgroundColor ? item.backgroundColor : "", padding: itemContainerPadding, margin: 5, position: "relative", "pointerEvents": type === "item" ? "none" : null }, additionalStyles);

								if (dialComponents.length > 0) {
									itemContainerPadding = "10px 18px 10px 10px";
									let showCommentsModalFunc = (selected) ? this.handleShowCommentsModal : null;

									let borderTopRightRadius = 15;
									let paddingLeft = 10;
									let paddingTop = 10;

									if (_style.hasOwnProperty("borderRadius") && _.isNumber(_style.borderRadius)) {
										borderTopRightRadius = _style.borderRadius;
									}
									if (_style.hasOwnProperty("borderTopRightRadius") && _.isNumber(_style.borderTopRightRadius)) {
										borderTopRightRadius = _style.borderTopRightRadius;
										if (borderTopRightRadius > 15) {
											paddingLeft += borderTopRightRadius - 15;
											paddingTop += borderTopRightRadius - 15;
										}
									}

									commentsNotesIcon =
										<div onClick={showCommentsModalFunc} style={{ padding: 10, paddingLeft, paddingTop, position: "absolute", width: 30, minHeight: 30, right: -2, top: -2, borderBottomLeftRadius: 15, borderTopRightRadius, backgroundColor: borderColor, display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "center", alignItems: "center", zIndex: 10, cursor: (selected) ? "pointer" : "", pointerEvents: disabled ? "none" : "all" }}>
											{dialComponents}
										</div>;
								}

								let innerItemComponent = <div style={{ padding: itemContainerPadding, pointerEvents: disabled ? "none" : "all" }}>
									<div style={{ display: "flex", alignItems: "center", width: "100%", pointerEvents: disabled ? "none" : "all" }}>
										{component}
									</div>
									{!webMode && commentsNotesIcon}
									{!webMode && mediaAttachmentsComponent}
									{notSelectedDiv}
									{disabled && <div style={{ position: "absolute", top: 0, right: 0, bottom: 0, left: 0, width: "100%", height: "100%", pointerEvents: "none" }} onClick={(e) => { e.stopPropagation(); }}></div>}
								</div>;


								// if (selected) {
								// 	innerItemComponent = <ClickNHold time={1} onClickNHold={this.handleShowCommentsModalLongPress}>
								// 		{innerItemComponent}
								// 	</ClickNHold>;
								// }



								if (self.props.showMode !== true) {
									// console.log(item);


									itemComponent = <div key={key} id={key} className={`player-item${selected ? " selected" : focusedModeSelection}${disabled ? " disabled" : ""}`} style={_style}
										onClick={(webMode || disabled) ? () => { return; } : () => self.setSelectedItem(self.context.tree, i, j, k, key)}
										ref={(el) => {
											self.itemRefs[key] = el;
											self.itemIndexes[key] = [i, j, k];
											self.itemRefsInfo[key] = {
												type: item.type,
												disabled
											};
										}}>
										{innerItemComponent}
										{!webMode && !selected &&
											<div style={{ position: "absolute", pointerEvents: "auto", top: 0, left: 0, bottom: 0, right: 0, opacity: focusedMode ? .8 : 1 }}
											onClick={(e) => {
												e.stopPropagation();
												self.setSelectedItem(self.context.tree, i, j, k, key);
											}}
											>
											</div>
										}
									</div>;
								} else {

									// if (selected) {
									// 	additionalStyles = _.assign(additionalStyles, Utils.getSelectedStyles(item.resolvedStyles.item));
									// }

									const _style = _.assign({}, { display: "flex", flexDirection: "column" }, additionalStyles);
									itemComponent = <div key={key} className={`showMode player-item${selected ? " selected" : ""}`} id={key} style={_style}>
										<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
											{component}
										</div>
										{mediaAttachmentsComponent}
										{commentsNotesIcon}
									</div>;
								}

								flatItems.push({ index: k, item: item, component: component });
							}

							self.itemRefsOrdered[itemCount] = key;
							itemCount++;

							return <OkButtonContext.Provider key={`ok-button-${item.guid}`} value={{
								styles: item.resolvedStyles && item.resolvedStyles.itemOkButton ? item.resolvedStyles.itemOkButton : {},
								label: item.itemButtonOkLabel,
								visibility: item.itemButtonOkVisibility
							}}>{itemComponent}</OkButtonContext.Provider>;
						});

						let sectionCompletionColor = self.getCompletionStateColor(section.completionState);

						let sectionBody;
						let bottomLeftBorderRadius = "3px";
						if (section.expanded) {
							bottomLeftBorderRadius = "0px";
							sectionBody = <Panel.Body>
								{items}
							</Panel.Body>;
						}

						let sectionComponent;

						if ((this.props.activity.firstLevel === "lists" || this.props.activity.firstLevel === "sections") && !_.isEmpty(_.trim(section.name))) {

							let _styles = {};
							let _titleStyles = {};

							const { resolvedStyles } = section;
							if (resolvedStyles) {
								if (resolvedStyles.section) {
									_styles = resolvedStyles.section;
								}

								if (resolvedStyles.title) {
									_titleStyles = resolvedStyles.title;
								}
							}

							sectionComponent = (Utils.isVisible(section)) ? <Panel key={"history-list" + i + "section" + j} style={{ borderColor: section.borderColor }} bsStyle="default" defaultExpanded={listCount === 1 && sectionCount === 1 ? true : false}>

								<Panel.Heading style={_.assign({}, { padding: "0px", backgroundColor: section.backgroundColor, color: section.color, border: "none" }, _styles)}>
									<div style={{ display: "flex", flexDirection: "row" }}>
										{!webMode && <div className="player-panel-heading-completion-status" style={{ "backgroundColor": sectionCompletionColor, bottomLeftBorderRadius }} />}
										<div className="player-panel-heading">
											<div className="player-panel-title" style={_titleStyles} onClick={() => { playerActions.toggleExpandNode(self.context.tree, i, j); }}>
												{section.name}
											</div>
										</div>
									</div>
								</Panel.Heading>
								{sectionBody}
							</Panel> : null;

						} else {
							sectionComponent =
								<div style={{ margin: 10, overflow: "auto" }}>
									{items}
								</div>
						}

						return sectionComponent;
					});

					let listCompletionColor = self.getCompletionStateColor(list.completionState);

					let listBody;
					let bottomLeftBorderRadius = "3px";
					if (list.expanded) {
						bottomLeftBorderRadius = "0px";
						listBody = <Panel.Body>
							{sections}
						</Panel.Body>;
					}

					let icon;
					if (list.iconType !== "" && !_.isUndefined(list.iconType)) {
						icon = <PlayerIcon entity={list} style={{ marginRight: "8px" }} />;
					}

					let _styles = {};
					let _titleStyles = {};

					const { resolvedStyles } = list;
					if (resolvedStyles) {
						if (resolvedStyles.list) {
							_styles = resolvedStyles.list;
						}

						if (resolvedStyles.title) {
							_titleStyles = resolvedStyles.title;
						}
					}

					let listComponent = (Utils.isVisible(list)) ? <Panel key={"history-list" + i} bsStyle="default" defaultExpanded={true} style={{ maxWidth: "1024px", width: "100%", borderColor: list.borderColor }}>
						<Panel.Heading style={_.assign({}, { padding: "0px", backgroundColor: list.backgroundColor, color: list.color, border: "none" }, _styles)}>
							<div style={{ display: "flex", flexDirection: "row" }}>
								<div className="player-panel-heading-completion-status" style={{ "backgroundColor": listCompletionColor, bottomLeftBorderRadius }}></div>
								<div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}></div>
								<div className="player-panel-heading">
									<div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
										{icon}
										<div className="player-panel-title" style={_titleStyles} onClick={() => { playerActions.toggleExpandNode(self.context.tree, i); }}>
											{list.name}
										</div>
									</div>
									<div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
										<span title="Expand all" style={{ "cursor": "pointer", "marginRight": "10px" }} onClick={() => self.handleListExpandAll(i)}><FontAwesome name="expand" /></span>
										<span title="Collapse all" style={{ "cursor": "pointer" }} onClick={() => self.handleListCollapseAll(i)}><FontAwesome name="compress" /></span>
									</div>
								</div>
							</div>
						</Panel.Heading>
						{listBody}
					</Panel> : null;

					if (this.props.activity.firstLevel === "lists") {
						return listComponent;
					} else {
						return (
							<div key="sections-wrapper" style={{ margin: 10, overflow: "auto" }}>
								{sections}
							</div>
						)
					}
				});
			}
		} catch (e) {
			console.error(e);
			alert(e.message);
			lists =
				<div>There was an error getting the content for the activity!</div>;
		}

		const _nameStyle = _.pick(Utils.getStyleAttribute(self.props.activity, [], ["activity", "title"]), ["fontSize", "color", "fontFamily", "fontWeight", "fontStyle"]);
		// onScroll={this.handleScroll}
		let listView = <div className="top-list-view" style={{ maxWidth: "1024px", width: "100%", marginLeft:"auto", marginRight:"auto"}}>
			<div style={{ height: this.state.paddingHeight ? this.state.paddingHeight - 100 : "auto" }} />
			<div><h3 style={_.assign({ marginLeft: 25, marginRight: 25, fontSize: "1.6em" }, _nameStyle)}>{self.props.activity.name}</h3> {lists}</div>
			<div style={{ height: this.state.paddingHeight ? this.state.paddingHeight + 50 : "auto" }} />
		</div>;
		//  onScroll={_.throttle(this.handleScroll, 200, { trailing: true, leading: true })}


		let scrollHandler = _.throttle(this.handleScroll, 200, { trailing: true, leading: true });

		let { listIndex, sectionIndex, itemIndex } = this.props.activity.selected;

		let playerCommentsModal = <PlayerCommentsModal listIndex={listIndex} sectionIndex={sectionIndex} itemIndex={itemIndex} onClickClose={this.handleCommentsModalClose} isOpen={this.props.showComments} />;

		const _styles = Utils.getStyleAttribute(self.props.activity, [], "activity")

		let backgroundImageSource = null;
		if (self.props.activity.hasOwnProperty("backgroundImage") && !_.isEmpty(self.props.activity.backgroundImage)) {
			backgroundImageSource = getUrlForValue(self.props.activity.backgroundImage, self.props.activity.id);
		}
		const addtProps = {};
		if (backgroundImageSource) {
			addtProps.backgroundImage = `url('${backgroundImageSource}')`;
			addtProps.backgroundRepeat = "no-repeat";
			addtProps.backgroundPosition = "center center";
			addtProps.backgroundAttachment = "fixed";
			// no - repeat center center fixed`;
			addtProps.backgroundSize = "cover";
		}
		console.log("Additiona;", addtProps, self.props.activity);
		const appliedStyles = _.assign({}, { width: "100%", height: "100%", overflowX: "hidden",visibility: self.state.visibility }, addtProps, _styles);

		let checklistView = <div className="player-procedure" style={appliedStyles} onScroll={scrollHandler} ref={(el) => { self.container = el; global.container = el }}>

			<div style={{ height: "50vh", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", color: "white" }}>
				{/* <FontAwesome style={Utils.getFontStyles(theme.placeholderStartProcedure)} name={theme.placeholderStartProcedure.iconName} /> */}
			</div>	
				{listView}
			<div style={{ height: "50vh", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", color: "white" }}>
				{/* <FontAwesome style={Utils.getFontStyles(theme.placeholderEndProcedure)} name={theme.placeholderEndProcedure.iconName} /> */}
			</div>	

			{playerCommentsModal}
			{this.props.associatedContent && this.props.associatedContent.show && <RankItemAnimatedCard />}
		</div>;

		return checklistView;
	}
}

ActivityPlayer.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	associatedContent: ["associatedContentCard"],
	activityTheme: ["activity", "theme"],
	appCapabilitiesPlayer: ["appCapabilities", "views", "player"],
	showComments: ["player", "showComments"],
	user: ["user"]
}, ActivityPlayer);